module.exports = __webpack_public_path__ + "static/media/hpe.5a51bea6.png";